module.exports = __webpack_public_path__ + "img/image-woman-in-videocall.19f0b20f.jpg";